<div #host class="mdw-swap" [class.fill-height]="fillHeight()">
  <div #content class="mdw-anim-content" [class.fill-height]="fillHeight()">
    @if (renderedModel() !== _void) {
      <ng-container
        [ngTemplateOutlet]="swapTemplate()"
        [ngTemplateOutletContext]="{ $implicit: renderedModel() }"
      ></ng-container>
    }
  </div>
</div>
